import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { useCommon } from "../Common/useCommon";
import services from "../../services/services.js";
import { ToastContext } from "../../context/ToastContext.js";
import { useLocation, useNavigate } from 'react-router-dom';
import { Urls } from "../../services/Urls.js";



export const useSignup = () => {
    const { showSuccess } = useContext(ToastContext);
    const location = useLocation().state
    const navigate = useNavigate();
    const { handleValidation } = useCommon()
    const [signupdata, setsignupdata] = useState("")
    const [error, setError] = useState({});
    const [captcha, setcaptcha] = useState({
        captchaCode:'',
        captchaId:""
    })
    const [imageSrc, setImageSrc] = useState('');
    const imageRef = useRef(null);


    useEffect(() => {
        if (imageRef.current && imageSrc) {
            imageRef.current.src = imageSrc;
        }
    }, [imageSrc]);


    useEffect(() => {
        fetchCaptcha();
    }, []);

    const fetchCaptcha = async () => {
        setError({})
        try {
            // Make the GET request to fetch captcha
            const response = await services.login(Urls("GETCAPTCHA"), {}, "GET", "image");
            // Check if the response was successful (status code 200)
            if (response.status === 200) {
                const contentType = response.headers["content-type"];
                setcaptcha((prevState) => ({...prevState,captchaId:response.headers['captcha-id']}))
                // Check if the response is an image
                if (contentType && contentType.includes("image/png")) {
                    const imageUrl = URL.createObjectURL(response.body); // Create an Object URL for the image                        
                    setImageSrc(imageUrl); // Set the image URL to display the captcha image
                } else {
                    setError('Expected image/png but got: ' + contentType);
                }
            } else {
                setError('Error fetching captcha: ' + response.statusText);
            }
        } catch (error) {
            setError('Error occurred while fetching captcha: ' + error.message);
        }
    };


    const handleSubmit = async (e) => {        
        e.preventDefault();
        // const err = {}
        if (!signupdata) {
            // err['user_loginname'] = "Please enter email/employee code"
            setError({user_loginname: "Please enter email/employee code"});
            return;
        }
        if (captcha.captchaCode === "") {
            // err['captcha'] = "Please enter Captcha"
            setError({captcha: "Please enter Captcha"})
            return;
        }
        const payload = {
            "employee_email_id": signupdata,
            "is_forget": !(location?.key === 'is_signup'),
            'user_captcha_id': captcha.captchaId,
            "user_captcha_code": captcha.captchaCode,
            "unique_device_id": ""
        };
        try {
            let response = await services.login(Urls("SIGNUP"), payload);
            if (response?.body?.data) {
                sessionStorage.setItem("platform", "local");
                showSuccess("success", "Your registration credentials have been sent via email");
                navigate("/reset-password", { state: signupdata });
            }
        } catch (err) {
            console.error(err, "error");
            setError({ apiError: err?.response?.data?.errorMessage || "Something went wrong!" });
        }
    };


    return useMemo(() => ({
        signupdata, setsignupdata, error, handleSubmit, setError, handleValidation, captcha, setcaptcha, imageSrc, imageRef,fetchCaptcha
    }), [signupdata, setsignupdata, error, handleSubmit, setError, handleValidation, captcha, setcaptcha, imageSrc, imageRef,fetchCaptcha]);
};
